import styled from 'styled-components'
import tw from 'twin.macro'
import harborIslandImg from '@/images/headers/tampa-bay-harbor-island.jpg'

interface HeroContainerProps {
  bgImage?: string
}

const HeroContainer = styled.div<HeroContainerProps>`
  ${tw`
    relative
    flex
    flex-col
    justify-center
    items-center
    min-h-[500px]
    h-[70vh]
    xl:h-[60vh]
    p-5
    bg-cover
    bg-center
    bg-no-repeat
  `}
  background-image: url(${props => props.bgImage ?? harborIslandImg});


  h1 {
    ${tw`
      relative
      z-10
      text-4xl
      md:text-5xl
      lg:text-6xl
      xl:text-7xl
      text-center
      max-w-screen-lg
      text-white
      font-bold
      leading-tight
    `}
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.7);
  }
`

interface HeroProps {
  title: string | JSX.Element
  backgroundImg?: string
}

export const Hero = ({ title, backgroundImg }: HeroProps) => {
  return (
    <HeroContainer bgImage={backgroundImg}>
      <h1>{title}</h1>
    </HeroContainer>
  )
}